import TalentListPage from '../components/Talent/TalentListPage'

// Все, кто когда-либо был в пресейле, включая тех, кого уже перевели в другой
// тип: режим «с историей» (без current_only) находит их по событиям смены типа
const PresaleHistory = () => {
  return (
    <>
      <title>Presale History | Talent Service</title>
      <TalentListPage
        talentType="presale"
        pageTitle="Presale History"
        pageDescription="Everyone who has ever been in presale, including those who have since moved to another type"
      />
    </>
  )
}

export default PresaleHistory
